module.exports = __webpack_public_path__ + "static/media/small_phone.dca44b3a.png";